module.exports = __webpack_public_path__ + "media/images/icon_camera_yellow-14d77e9180968ebb6c5bbbc01be3275b.png";